import axios, {AxiosResponse} from 'axios';
import {useState, useEffect} from 'react';
import {isDefined} from '../../types/type-guards';
// import {singletonFactory} from './common-utils';

/**
 * Objective of this module is to provide following features:
 * - [x] Simple wrapper for making network requests
 * - [ ] Latency Tracking
 * - [ ] Auto push GA analytics related to API endpoints
 * - [ ] Cancel if existing request over the air
 * - [ ] Retry as per specified count
 * - [ ] Short-Circuit request as per defined time
 * - [ ] Priority fetching
 * - [ ] No network response
 * - [ ] Logging utility logger/index.ts or logger.server.ts
 */

const xhrHelperInstance = axios.create();
const cancelToken = axios.CancelToken;

export type xhrType = 'GET' | 'POST';

// interface xhrGetCallCacheType<T> {
//   [key: string]: Promise<AxiosResponse<T>>;
// }

// interface ICacheConfig<ResponseDataGeneric> {
//   validator: (data: ResponseDataGeneric) => boolean;
//   expiry: Date;
// }

// type xhrGetCallCacheType = Record<string, Promise<AxiosResponse<any>>>;

// const xhrGetCallCache: xhrGetCallCacheType = {};

interface IXhrHelper<RequestDataGeneric> {
  name: string;
  type: xhrType;
  url: string;
  requestData?: RequestDataGeneric;
  options?: object;
}

export const xhrHelper = <RequestDataGeneric, ResponseDataGeneric>({
  name,
  type,
  url,
  requestData,
  options,
}: IXhrHelper<RequestDataGeneric>): // name: string,
// type: xhrType,
// url: string,
// requestData: IXhrData<QueryParamsGeneric, PostDataGeneric>,
// retry,
// cancel = true,

// cache: boolean = false,
// cacheConfig?: ICacheConfig<ResponseDataGeneric>,
Promise<AxiosResponse<ResponseDataGeneric>> => {
  let params = {};

  if (isDefined(requestData)) {
    params = {...requestData};
  }

  // if (cache && xhrGetCallCache[url + JSON.stringify(queryParams)]) {
  //   return xhrGetCallCache[url + JSON.stringify(queryParams)];
  // }

  // if (cache) {
  // returnedPromise.then(resp => {
  // if (isDefined(validator) && validator(resp.data))
  // xhrGetCallCache[url + JSON.stringify(queryParams)] = Promise.resolve(resp);
  // });
  // }

  let returnedPromise;

  // can use similar to caching strategy to hold-on to cancelToken, if same request refired, then
  // cancel, else on success/failure flush cancelToken
  // const source = cancelToken.source();
  if (type === 'GET') {
    returnedPromise = xhrHelperInstance.get<ResponseDataGeneric>(url, {params: {...params}});
  }
  if (type === 'POST') {
    returnedPromise = xhrHelperInstance.post<ResponseDataGeneric>(url, params, options);
  }

  return returnedPromise;
};

// export const useXhrHelper = function<RequestDataGeneric, ResponseDataGeneric>(
//   args: IXhrHelper<RequestDataGeneric>,
// ) {
//   const [isPending, setIsPending] = useState(true);
//   const [data, setData] = useState({});
//   const [error, setError] = useState({});
//   const responsePromise = xhrHelper<RequestDataGeneric, ResponseDataGeneric>({...args});

//   useEffect(() => {
//     responsePromise
//       .then(data => {
//         setData(data);
//         setIsPending(false);
//       })
//       .catch(err => {
//         setError(err);
//         setIsPending(false);
//       });

//     setIsPending(false);
//   }, []);

//   return [error as Error, data as ResponseDataGeneric, isPending];
//   // return useAsync({promise: responsePromise});
// };
